<template lang='pug'>
.stats-item
  .stats-bullet
    .stats-icon(v-if="icon" :class="'icon-'+icon")
    .stats-text {{title}}
  .stats-bottom
    div
      .stats-number.text--right.text--48.text--bold.color--blueCornFlower {{getNumberString(info)}}
</template>
<script>
import { getNumberString } from '@/plugins/tool.js'

export default {
  props: {
    icon: String,
    title: String,
    info: Number,
    subText: String
  },
  data() {
    return {
      getNumberString: getNumberString
    }
  }
}
</script>
